import { render, staticRenderFns } from "./paySucceed.vue?vue&type=template&id=0f40f062&scoped=true&"
var script = {}
import style0 from "./paySucceed.vue?vue&type=style&index=0&id=0f40f062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40f062",
  null
  
)

component.options.__file = "paySucceed.vue"
export default component.exports